import React from 'react';
import './sorting.css'

export default function Sorting({setSortId}) {
    return (
      <div className='sortHolder'>
        <h4 className='sort'>sort by:- </h4>
          <select onChange={(e)=>{setSortId(e.target.value)}} className='sortOption'>
              <option value="0">What's New</option>
              <option value="2">Better Discount</option>
              <option value="1">Price low to high</option>
              <option value="3">Price high to low</option>
              
          </select>
      </div>
    )
  }
  